import * as React from 'react';
import { Checkbox } from '@/hen-ui/atomics/Checkbox';
import { cn } from '@/hen-ui/utils/cn';
import {
  checkboxButtonSizeVariants,
  type CheckboxButtonSizeVariantProps,
} from './checkbox-button.variants';

export interface CheckboxButtonProps
  extends React.ComponentPropsWithoutRef<typeof Checkbox>,
    CheckboxButtonSizeVariantProps {
  label: string;
  error?: boolean;
  disabled?: boolean;
  checked?: boolean;
}

export const CheckboxButton = React.forwardRef<
  React.ElementRef<typeof Checkbox>,
  CheckboxButtonProps
>(
  (
    { label, error, disabled, checked, size = 'sm', className, ...props },
    ref,
  ) => {
    return (
      <Checkbox
        isButton
        ref={ref}
        label={label}
        error={error}
        disabled={disabled}
        checked={checked}
        className={cn(
          // Base border and background — root is the Label (full hit target)
          'font-bold',
          'inline-flex justify-center rounded-max border-2 border-neutral-200 bg-transparent transition-colors bg-white',
          // Focus state
          'focus-within:border-neutral-500 focus-within:bg-neutral-50 focus-within:ring-4 focus-within:ring-neutral-100 hover:border-neutral-500 hover:ring-4 hover:ring-neutral-100 hover:bg-neutral-50',
          // Error state
          error &&
            'border-error-500 focus-within:border-error-500 focus-within:ring-error-300 hover:border-error-500 hover:ring-error-300',
          // Disabled state
          disabled &&
            'opacity-50 cursor-not-allowed hover:ring-0 hover:border-neutral-200 hover:bg-white',
          // Size — same options as Button (sm, lg)
          checkboxButtonSizeVariants({ size }),
          className,
        )}
        {...props}
      />
    );
  },
);

CheckboxButton.displayName = 'CheckboxButton';
